import "./TabBar.scss"
import React from "react"
import classnames from "classnames"
import { Route, Link } from "react-router-dom"

export const TabLink = ({ to, label, icon, ...rest }) => {
  return (
    <Route
      path={to}
      children={({ match }) => (
        <li className={classnames("TabBarLink", match && "TabBarLink-active")}>
          <Link to={to} children={label} {...rest} />
        </li>
      )}
    />
  )
}

TabLink.displayName = "TabLink"

export const TabBar = ({ children }) => {
  return (
    <nav className="TabBar">
      <ul>{children}</ul>
    </nav>
  )
}

TabBar.displayName = "TabBar"



// WEBPACK FOOTER //
// ./src/lib/TabBar.js